import { Box, Card, Typography, IconButton, TextField, Tabs, Tab, InputAdornment, Button, Checkbox } from '@mui/material';
import LayoutAccessManagement from 'components/structure/LayoutAccessManagement';
import { useContext, useEffect, useState } from 'react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import crossIcon from 'assets/user-access/crossblue.svg'
import dragIcon from 'assets/user-access/drag-icon.svg'
import dragIconOrange from 'assets/user-access/drag-icon-orange.svg'
import iconSearchs from 'assets/user-access/searchIcon.svg'
import rightArrow from 'assets/user-access/rightarrow-blue.svg'
import bottomArrow from 'assets/user-access/downarrow-blue.svg'
import { useLocation, useNavigate } from 'react-router-dom';
import UserFunctionalityService from 'services/UserFunctionalityService';
import RuleService from 'services/RuleService';
import { SnackbarContext } from 'context/snackBarContext';
import { AuthData } from "auth/AuthWarpper";

const RoleEdit = (props) => {
    const navigate = useNavigate();
    const { user } = AuthData();
    const location = useLocation();
    const { rowData, fromUrl } = location.state || {};
    const { setOpenAlert, setSeverity, setMessage } = useContext(SnackbarContext);
    const [subMenuOpen, setSubMenuOpen] = useState({});
    const [searchTerm, setSearchTerm] = useState('');
    const [filteredItems, setFilteredItems] = useState([]);
    const [mainContentItems, setMainContentItems] = useState([]);
    const [conflictData, setConflictData] = useState([]);
    const [selectedTab, setSelectedTab] = useState(0);
    const [functionalities, setFunctionalities] = useState([]);
    const [nonPrivilegedFunctionalities, setNonPrivilegedFunctionalities] = useState([]);
    const [dummy, setDummy] = useState(0); // Dummy state to trigger re-render
    const transformData = (data) => {
        const functionalities = [];

        for (const [key, value] of Object.entries(data)) {
            const functionality = {
                name: key, // Use the key (MVP01, MVP02) as the functionality name
                key: key.toLowerCase(), // Use lowercase key for the key
                children: []
            };

            for (const [subKey, modules] of Object.entries(value)) {
                const subFunctionality = {
                    name: subKey,
                    key: subKey.toLowerCase().replace(/ /g, ''), // Replace spaces for key
                    children: modules.map(module => ({
                        name: module["functionality_name"],
                        key: module["functionality_id"],
                        isNew: module["new_functionality"],
                    }))
                };

                functionality.children.push(subFunctionality);
            }

            functionalities.push(functionality);
        }
        return functionalities;
    };
console.log('rowData', rowData)
    const isconflicted = (id) => {
        if (user?.profileName == 'Administrator' || user?.profileName == 'IT Admin Access Mgt') {
            return false
        }
        const keysInA = mainContentItems.map(item => item.key); // Extract keys from maincontents
        for (const conflict of conflictData) {
            if (conflict.functionalityId1 == id) {
                // Check functionalityId2
                if (keysInA.includes(conflict.functionalityId2)) {
                    return true
                }
            } else if (conflict.functionalityId2 === id) {
                // Check functionalityId1
                if (keysInA.includes(conflict.functionalityId1)) {
                    return true
                }
            }
        }
        return false; // No conflict found
    };

    useEffect(() => {
        fetchConflictingIndicator()
        UserFunctionalityService.FetchUserFunctionalityRoleTracks().then((res) => {
            let data = res?.data?.response
            setFunctionalities(transformData(data?.Privileged))
            setNonPrivilegedFunctionalities(transformData(data['Non-Privileged']))
            mapExistingFunctionality()
        }).catch((error) => {
            setSeverity("error");
            setMessage(error?.response?.data?.message || error?.message);
            setOpenAlert(true);
            console.log(error)
        })
    }, [])

    const fetchConflictingIndicator = () => {
        UserFunctionalityService.getActiveRulesList().then((res) => {
            let data = res?.data?.response;
            setConflictData(data)
        }).catch((error) => {
            console.log(error)
        })
    }

    const mapExistingFunctionality = () => {
        let newItem = []
        let data = fromUrl == "/administratorCreation" ? rowData?.roleFunctionalityOriginal : rowData?.functionalities;
        if (!data) return
        data?.forEach((ele) => {
            let item = {
                key: ele?.functionality_id,
                name: ele?.functionality_name,
                isReadOnly: ele?.isReadOnly || false
            };
            newItem.push(item)
        })
        setMainContentItems(newItem);

    }

    const handleToggleSubMenu = (key) => {
        setSubMenuOpen((prevState) => ({
            ...prevState,
            [key]: !prevState[key],
        }));
    };

    const handleSearchChange = (event) => {
        const value = event.target.value;
        setSearchTerm(value);

        if (value) {
            const currentFunctionalities = selectedTab === 0 ? functionalities : nonPrivilegedFunctionalities;
            const matches = findMatches(value.toLowerCase(), currentFunctionalities);
            setFilteredItems(matches);
            if (matches.length > 0) {
                handleToggleSubMenu(matches[0].key);
            } else {
                setFilteredItems([]);
            }
        } else {
            setFilteredItems([]);
            resetMenuVisibility();
        }
    };

    const resetMenuVisibility = () => {
        functionalities.forEach(func => {
            setSubMenuOpen((prev) => ({ ...prev, [func.key]: true }));
            if (func.children) {
                func.children.forEach(child => {
                    setSubMenuOpen((prev) => ({ ...prev, [child.key]: true }));
                    if (child.children) {
                        child.children.forEach(grandchild => {
                            setSubMenuOpen((prev) => ({ ...prev, [grandchild.key]: true }));
                        });
                    }
                });
            }
        });
    };


    const findMatches = (searchString, data) => {
        const result = [];
        data.forEach(item => {
            // Check if MVP name matches
            if (item.name.toLowerCase().includes(searchString.toLowerCase())) {
                result.push(item);
            } else {
                const filteredChildren = searchChildren(item.children, searchString);
                if (filteredChildren.length > 0) {
                    result.push({ ...item, children: filteredChildren });
                }
            }
        });

        return result;
    };

    const searchChildren = (children, searchString) => {
        const filtered = [];
        for (const child of children) {
            // Check if Module name matches
            if (child.name.toLowerCase().includes(searchString.toLowerCase())) {
                filtered.push(child);
            } else {
                const matchingFunctionalities = child.children.filter(func =>
                    func.name.toLowerCase().includes(searchString.toLowerCase())
                );

                if (matchingFunctionalities.length > 0) {
                    filtered.push({ ...child, children: matchingFunctionalities });
                }
            }
        }

        return filtered;
    };


    const handleTabChange = (event, newValue) => {
        // setMainContentItems([]);
        setSelectedTab(newValue);
        setSearchTerm('');
        setFilteredItems([]);
        resetMenuVisibility();
    };

    const handleDragEnd = (result) => {
        if (!result.destination) return;
        const { source, destination, draggableId } = result;
        const [key, name] = draggableId.split('|');
        if (isconflicted(key)) {
            setSeverity("error");
            setMessage('Conflictive Functionality');
            setOpenAlert(true);
            return;
        }
        // Handling dragging to the main content area
        if (source.droppableId === 'menu' && destination.droppableId === 'content') {
            const existingItem = mainContentItems.find(item => item.key === key);
            if (!existingItem) {
                const newItem = {
                    key: key,
                    name: name,
                    isReadOnly: false // Initialize as not read-only
                };
                setMainContentItems(prev => [...prev, newItem]);
            }
        }
        // Handling reordering within the main content area
        else if (source.droppableId === 'content' && destination.droppableId === 'content') {
            const reorderedItems = Array.from(mainContentItems);
            const [movedItem] = reorderedItems.splice(source.index, 1);
            reorderedItems.splice(destination.index, 0, movedItem);
            setMainContentItems(reorderedItems);
        }
    };

    const handleRemoveFromContent = (key) => {
        setMainContentItems(prev => prev.filter(item => item.key !== key));
        setFunctionalities([])
        setNonPrivilegedFunctionalities([])
        setTimeout(() => {
            setFunctionalities(functionalities)
            setNonPrivilegedFunctionalities(nonPrivilegedFunctionalities)
        }, 1)
        setDummy(prev => prev + 1);
    };

    const isInMainContent = (key) => {
        return mainContentItems.some(item => item.key === key);
    };
    function transformArray(arr) {
        return arr.map(item => ({
            "functionality_id": item.key,
            "functionality_name": item.name,
            "isReadOnly": item.isReadOnly || false
        }));
    }
    const onsubmit = () => {
        let roleId = ''
        if (fromUrl == '/administratorCreation' || fromUrl == 'roleCreation') {
            roleId = rowData['profileId']
        } else {
            roleId = rowData['role_id']
        }
        let data =
        {
            "createdByUser": user?.userName,
            "modifiedByUser": user?.userName,
            "role_id": roleId,
            "functionalities": transformArray(mainContentItems)
        }
             
        UserFunctionalityService.PostUserFunctionalityMapModules(data).then((res) => {
            let data = res?.data?.response
            setSeverity("success");
            setMessage("Added successfully");
            setOpenAlert(true);
            navigate(fromUrl, { state: { rowData: data } })
        }).catch((error) => {
            setSeverity("error");
            setMessage(error?.response?.data?.message || error?.message);
            setOpenAlert(true);
            console.log(error)
        })

    }
    const renderMenuItems = (items) => {

        return <div>
            <TextField
                variant="outlined"
                value={searchTerm}
                onChange={handleSearchChange}
                placeholder="Search"
                sx={{ margin: '10px' }}
                InputProps={{
                    endAdornment: (
                        <InputAdornment position="start">
                            <img src={iconSearchs} />
                        </InputAdornment>
                    ),
                    sx: {
                        fontStyle: "italic",
                        height: "32px",
                        fontSize: "14.1px",
                        padding: "0px",
                        "& .MuiOutlinedInput-input": { padding: "0px 5px", border: "none", backgroundColor: "#FFF !important" },
                        "& .MuiOutlinedInput-notchedOutline": {
                            border: " 1.176px solid #0E2B63)"
                        }
                    }
                }}
            />
            <VerticalLine />
            <Tabs
                value={selectedTab}
                onChange={handleTabChange}
                sx={{ '&.MuiTabs-indicator': { backgroundColor: 'red' } }}
            >
                <Tab className='editroletab' label="Privilege" sx={{ width: "50%", fontSize: "14px", backgroundColor: selectedTab === 0 ? '#0E2B63' : 'transparent', color: selectedTab === 0 ? '#fff !important' : 'black' }} />
                <Tab className='editroletab' label="Non-Priviledge" sx={{ width: "50%", fontSize: "14px", backgroundColor: selectedTab === 1 ? '#0E2B63' : 'transparent', color: selectedTab === 1 ? '#fff !important' : 'black' }} />
            </Tabs>
            <VerticalLine />
            {items.map((func) => (
                <Box key={func.key}>
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            cursor: 'pointer',
                            margin: '10px 0',
                            paddingLeft: '10px',
                            color: isInMainContent(func.key) ? '#EF7D00' : '#191E31',
                            opacity: isInMainContent(func.key) ? 0.5 : 1,
                        }}
                        onClick={() => handleToggleSubMenu(func.key)}
                    >
                        <Typography sx={{ fontSize: "14px", fontWeight: 600, fontFamily: 'Montserrat' }} variant="body1">{func.name}</Typography>
                        <IconButton size="small" sx={{ marginLeft: 'auto' }}>
                            {subMenuOpen[func.key] ? <img src={rightArrow} /> : <img src={bottomArrow} />}
                        </IconButton>
                    </Box>
                    <VerticalLine />
                    {subMenuOpen[func.key] && (
                        <Box>
                            {func.children && func.children.map((child) => (
                                <Box key={child.key}>
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            cursor: 'pointer',
                                            margin: '5px 0',
                                            paddingLeft: '25px',
                                            color: isInMainContent(child.key) ? '#EF7D00' : '#191E31',
                                            opacity: isInMainContent(child.key) ? 0.5 : 1,
                                        }}
                                        onClick={() => handleToggleSubMenu(child.key)}
                                    >
                                        <Typography sx={{ fontSize: "14px", fontWeight: 600, fontFamily: 'Montserrat' }} variant="body2">{child.name}</Typography>
                                        <IconButton size="small" sx={{ marginLeft: 'auto' }}>
                                            {subMenuOpen[child.key] ? <img src={rightArrow} /> : <img src={bottomArrow} />}
                                        </IconButton>
                                    </Box>
                                    <VerticalLine />
                                    {subMenuOpen[child.key] && (
                                        <Box>
                                            {child.children && child.children.map((grandchild, ind) => (
                                                <Draggable key={grandchild.key} draggableId={`${grandchild.key}|${grandchild.name}`}
                                                    // draggableId={grandchild.key}
                                                    name={grandchild?.name} index={ind}>
                                                    {(provided) => (
                                                        <>
                                                            <Box
                                                                ref={provided.innerRef}
                                                                {...provided.draggableProps}
                                                                {...provided.dragHandleProps}
                                                                sx={{
                                                                    backgroundColor: '#fff',
                                                                    borderRadius: '4px',
                                                                    paddingLeft: '25px',
                                                                    color: (grandchild?.isNew) ? '#EF7D00' : '#191E31',
                                                                    opacity: isInMainContent(grandchild.key) ? 0.4 : 1,
                                                                }}
                                                            >
                                                                <Box sx={{ display: "flex", padding: "10px 0px" }}>
                                                                    <Box sx={{ paddingTop: "2px" }}>

                                                                        <img src={(grandchild?.isNew) ? dragIconOrange : dragIcon} />
                                                                    </Box>
                                                                    <Typography sx={{ fontWeight: isInMainContent(grandchild.key) ? 600 : 500, fontSize: "14px", fontFamily: 'Montserrat', paddingLeft: "6px" }} variant="body2">{grandchild.name}</Typography>
                                                                </Box>

                                                            </Box>
                                                            <VerticalLine />
                                                        </>
                                                    )}

                                                </Draggable>
                                            ))}
                                        </Box>
                                    )}
                                </Box>
                            ))}
                        </Box>
                    )}
                </Box>
            ))}
        </div>
    };

    const VerticalLine = () => {
        return (
            < Box
                sx={{
                    width: '100%',
                    height: '2px',
                    backgroundColor: '#0E2B63',
                    opacity: 0.2,
                    margin: '0 auto'
                }}
            />
        );
    };

    // Add this function to handle checkbox toggle
    const handleReadOnlyToggle = (key) => {
        setMainContentItems(prev => 
            prev.map(item => 
                item.key === key 
                    ? { ...item, isReadOnly: !item.isReadOnly } 
                    : item
            )
        );
    };

    return (
        <LayoutAccessManagement title="Access Management">
            <Card
                className='Access-Management-Layout'
                sx={{
                    backgroundColor: "#f3f5f8",
                    color: "white",
                    marginBottom: "30px",
                    padding: "20px",
                    border: "none",
                    boxShadow: "0px 0px 10px 0px rgba(0, 0, 0, 0.1)",
                    display: "flex",
                    justifyContent: "center"
                }}
            >
                <Box sx={{ width: "621px", marginTop: "40px", marginBottom: "40px", borderRadius: '6px', backgroundColor: "#fff", height: "676px" }}>
                    <Box className="roleEditHead">
                        <Box className="roleEditHeader">Available Functionalities</Box>
                        <Box className="roleEditHeader"  sx={{marginRight:"-20px"}} >Assigned Functionalities</Box>
                        <Box className="roleEditHeader" sx={{marginRight:"40px"}}>Read Only</Box>
                    </Box>
                    <Box sx={{ display: 'flex', height: '500px' }}>
                        <DragDropContext onDragEnd={handleDragEnd}>
                            <Droppable droppableId="menu">
                                {(provided) => (
                                    <Box
                                        ref={provided.innerRef}
                                        {...provided.droppableProps}
                                        sx={{
                                            width: "242px",
                                            backgroundColor: '#fff',
                                            borderRadius: '6px',
                                            maxHeight: '500px',
                                            overflowY: 'auto',
                                            scrollbarWidth: 'none',
                                            '&::-webkit-scrollbar': { display: 'none' },
                                        }}
                                    >
                                        {searchTerm ? renderMenuItems(filteredItems) : renderMenuItems(selectedTab === 0 ? functionalities : nonPrivilegedFunctionalities)}
                                        {provided.placeholder}
                                    </Box>
                                )}
                            </Droppable>
                            <Box
                                sx={{
                                    width: '2px',
                                    height: '100%',
                                    backgroundColor: '#0E2B63',
                                    opacity: 0.2,
                                    margin: '0 auto'
                                }}
                            />
                            <Droppable droppableId="content">
                                {(provided) => (
                                    <Box
                                        ref={provided.innerRef}
                                        {...provided.droppableProps}
                                        sx={{
                                            width: "379px",
                                            borderRadius: '6px',
                                            overflowY: 'auto',
                                        }}
                                    >
                                        <Box>
                                            {mainContentItems.map((item, index) => (
                                                <Draggable key={item.key} draggableId={`${item.key}|${item.name}`} index={index}>
                                                    {(provided) => (
                                                        <Box
                                                            ref={provided.innerRef}
                                                            {...provided.draggableProps}
                                                            {...provided.dragHandleProps}
                                                            sx={{
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                padding: '2px 20px',
                                                                color: "#191E31",
                                                                fontSize: "14px"
                                                            }}
                                                        >
                                                            <Typography 
                                                                sx={{ 
                                                                    fontSize: "14px", 
                                                                    fontWeight: 500, 
                                                                    fontFamily: 'Montserrat',
                                                                    width: '60%'
                                                                }} 
                                                                variant="body1"
                                                            >
                                                                {item.name}
                                                            </Typography>
                                                            <Box sx={{ 
                                                                display: 'flex', 
                                                                alignItems: 'center',
                                                                marginLeft: 'auto',
                                                                marginRight: '50px'
                                                            }}>
                                                                <Checkbox
                                                                    checked={item.isReadOnly || false}
                                                                    onChange={() => handleReadOnlyToggle(item.key)}
                                                                    onClick={(e) => e.stopPropagation()}
                                                                    sx={{
                                                                        color: '#112A63',
                                                                        '&.Mui-checked': {
                                                                            color: '#112A63',
                                                                        },
                                                                        '& .MuiSvgIcon-root': {
                                                                            fontSize: 20
                                                                        }
                                                                    }}
                                                                />

                                                            </Box>
                                                            <IconButton
                                                                size="small"
                                                                onClick={() => handleRemoveFromContent(item.key)}
                                                            >
                                                                <img src={crossIcon} />
                                                            </IconButton>
                                                        </Box>
                                                    )}
                                                </Draggable>
                                            ))}
                                            {provided.placeholder}
                                        </Box>
                                    </Box>
                                )}
                            </Droppable>
                        </DragDropContext>
                    </Box>
                    <VerticalLine />
                    <Box sx={{ display: "flex", justifyContent: "center", alignItems: "cemter", margin: "40px 10px" }}>
                        <Button
                            sx={{
                                justifyContent: "center",
                                borderRadius: 4,
                                minWidth: 130,
                                minHeight: 54,
                                background: "#737D86",
                                marginLeft: "20px",
                                "&:hover": {
                                    backgroundColor: "#737D86",
                                },
                            }}
                            variant="contained"
                            type="button"
                            onClick={(e) => navigate(-1)}
                        >
                            {"BACK"}
                        </Button>
                        {/* <Button
                            sx={{
                                justifyContent: "center",
                                borderRadius: 4,
                                minWidth: 156,
                                minHeight: 54,
                                background: "#EF7D00",
                                marginLeft: "20px",
                                "&:hover": {
                                    backgroundColor: "#EF7D00",
                                },
                            }}
                            variant="contained"
                            type="button"
                            // onClick={(e) => navigate('/roleAssign')}
                            onClick={(e) => onsubmit()}

                        >
                            {"SUBMIT"}
                        </Button> */}
                        <Button
                            sx={{
                                justifyContent: "center",
                                borderRadius: 4,
                                minWidth: 156,
                                minHeight: 54,
                                background: "#112A63",
                                marginLeft: "20px",
                                "&:hover": {
                                    backgroundColor: "#112A63",
                                },
                            }}
                            variant="contained"
                            type="button"
                            onClick={() => navigate('/roleAssign',{state:{rowData:rowData ,nonPrivilegedFunctionalities:nonPrivilegedFunctionalities,functionalities:functionalities,mainContentItems:mainContentItems, fromUrl:fromUrl}})}

                        >
                            Next
                        </Button>
                    </Box>
                </Box>
            </Card>
        </LayoutAccessManagement>
    );
};

export default RoleEdit;











// {
//     "Non-Privileged": {
//         "MVP01 (Planning)": {
//             "Module1": [
//                 {
//                     "functionality_id": "7c2a8582-e716-42bc-8d34-219da6225ad0",
//                     "functionality_name": "Functionality 2",
//                     "new_functionality": true
//                 },
//                 {
//                     "functionality_id": "abaf532d-925c-4ed2-acc2-5e69e9a79171",
//                     "functionality_name": "Functionality 3",
//                     "new_functionality": true
//                 }
//             ]
//         },
//         "MVP02 (Growing)": {
//             "GROWING": [
//                 {
//                     "functionality_id": "ddc7074f-d00f-4e6b-a95e-91ec20bd95b2",
//                     "functionality_name": "Culture Registration",
//                     "new_functionality": true
//                 }
//             ]
//         },
//         "MVP02 (ESG)": {
//             "Manage Operations": [
//                 {
//                     "functionality_id": "ac6cd0a5-fde0-4838-82b5-a134fbf3735a",
//                     "functionality_name": "Functionality 4",
//                     "new_functionality": true
//                 }
//             ]
//         }
//     },
//     "Privileged": {
//         "MVP01 (Planning)": {
//             "Module1": [
//                 {
//                     "functionality_id": "f8660c2e-bd3c-4591-8fbe-77bab829be33",
//                     "functionality_name": "Functionality 1",
//                     "new_functionality": true
//                 }
//             ]
//         },
//         "MVP02 (Growing)": {
//             "GROWING": [
//                 {
//                     "functionality_id": "1cb6ab41-7050-4514-93e1-3af5d56329fa",
//                     "functionality_name": "Hierarchy Registration",
//                     "new_functionality": true
//                 },
//                 {
//                     "functionality_id": "0670577a-14f5-4a33-bc4c-6195da71bdad",
//                     "functionality_name": "Spacing Registration",
//                     "new_functionality": true
//                 }
//             ]
//         },
//         "MVP02 (ESG)": {
//             "Manage Operations": [
//                 {
//                     "functionality_id": "c05dffa5-2381-497c-8f31-67b02f7911b9",
//                     "functionality_name": "Season Registration",
//                     "new_functionality": false
//                 },
//                 {
//                     "functionality_id": "c50cfe0d-6216-430d-ba58-6c07651fb492",
//                     "functionality_name": "Module Registration",
//                     "new_functionality": false
//                 },
//                 {
//                     "functionality_id": "63d43a00-22f8-4339-97d3-7dde6307b3cf",
//                     "functionality_name": "Crop Stage Registration",
//                     "new_functionality": false
//                 },
//                 {
//                     "functionality_id": "cac2dc27-9fe4-4565-b72d-7fd97b29496d",
//                     "functionality_name": "Crop Stage Calendar",
//                     "new_functionality": false
//                 },
//                 {
//                     "functionality_id": "86f48434-2dca-4590-9cd1-9e6f0b034966",
//                     "functionality_name": "Hierarchy Configuration",
//                     "new_functionality": false
//                 },
//                 {
//                     "functionality_id": "0ea9c7b9-9195-49a8-b50a-b74c852ee22f",
//                     "functionality_name": "Questionnaire Setup",
//                     "new_functionality": false
//                 }
//             ],
//             "Access Control": [
//                 {
//                     "functionality_id": "8116f132-d819-491f-949f-b000b03eb2be",
//                     "functionality_name": "Manage Profiles",
//                     "new_functionality": false
//                 },
//                 {
//                     "functionality_id": "95990bb2-79c5-4a89-8fc5-b6fd8b779bd0",
//                     "functionality_name": "Manage Users",
//                     "new_functionality": false
//                 }
//             ],
//             "Data Import": [
//                 {
//                     "functionality_id": "d573d9bd-d33e-4265-be2f-2f82c8330167",
//                     "functionality_name": "Import Contract",
//                     "new_functionality": false
//                 },
//                 {
//                     "functionality_id": "93098ea3-455c-4ee8-bdff-e06f9e637cc1",
//                     "functionality_name": "Import Farmer",
//                     "new_functionality": false
//                 },
//                 {
//                     "functionality_id": "d3235945-c813-4089-a8b8-e7cd7c6dd0c4",
//                     "functionality_name": "Import Hierarchy",
//                     "new_functionality": false
//                 }
//             ]
//         }
//     }
// }
